var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 161,
    viewBox: "0 0 251 161",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.793 22.626a21.523 21.523 0 0 1 10.466-2.62c3.63-.087 7.217.785 10.404 2.527L245.29 111.83a10.993 10.993 0 0 1 3.54 3.082 6.52 6.52 0 0 1 1.169 3.73 7.643 7.643 0 0 1-4.463 6.164l-58.022 33.598a23.642 23.642 0 0 1-21.547 0L12.402 69.323A7.582 7.582 0 0 1 8 63.16a8.507 8.507 0 0 1 4.802-6.843l57.991-33.69z",
    fill: "#E5F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.565 60.54 154.033 89.24a23.68 23.68 0 0 0 23.844 0l57.947-33.43A13.216 13.216 0 0 0 250 104.898c0-4.728-2.521-9.095-6.61-11.452-47.043-27.38-107.085-61.736-154.034-89.24a23.711 23.711 0 0 0-23.813 0L7.596 37.636A13.247 13.247 0 0 0 1 49.08a13.247 13.247 0 0 0 6.565 11.46z",
    stroke: "#0E1D31",
    fill: "#CCE7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.984 3.532a21.842 21.842 0 0 1 10.415-2.528c3.632-.07 7.22.8 10.415 2.528L242.285 92.92c1.39.76 2.598 1.812 3.544 3.083A6.505 6.505 0 0 1 247 99.64a7.644 7.644 0 0 1-4.468 6.165l-58.085 33.598a23.69 23.69 0 0 1-21.57 0L8.408 50.013A7.52 7.52 0 0 1 4 43.85a8.63 8.63 0 0 1 4.93-6.781L66.984 3.532z",
    stroke: "#0E1D31",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.13 5.755-5.797 3.384c-1.013.585-1.013 1.508 0 2.093l.797.461c2.3 1.354 2.27 3.508 0 4.862L34.596 34.647a9.178 9.178 0 0 1-8.313 0l-.798-.462a4.008 4.008 0 0 0-3.65 0l-5.798 3.539c-4.05 2.338-4.05 6.153 0 8.461l151.262 88.06a16 16 0 0 0 14.57 0l55.094-31.907c4.05-2.338 4.05-6.154 0-8.492L85.701 5.755a16 16 0 0 0-14.57 0",
    stroke: "#0E1D31",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.807 107.32a1.251 1.251 0 0 1-.572.559l-24.986 14.903a1.436 1.436 0 0 1-1.138.167 1.483 1.483 0 0 1-.909-.726c-.413-.747-.173-1.699.542-2.142l24.986-14.872a1.51 1.51 0 0 1 2.077.559 1.659 1.659 0 0 1 0 1.552z",
    fill: "#CCE7EC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E1D31",
    fill: "#66B6C6",
    d: "m144.53 91.793 13.351 7.723 26.428-15.3-13.334-7.7z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76 41)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3E4A5A",
    strokeLinecap: "square",
    d: "m6.5 26.5 40-23"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#66B6C6",
    cx: 6.4,
    cy: 27,
    rx: 6.4,
    ry: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CFD2D6",
    cx: 27.4,
    cy: 15,
    rx: 6.4,
    ry: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CFD2D6",
    cx: 46.4,
    cy: 4,
    rx: 6.4,
    ry: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.2cf84f0f.svg";
export { ForwardRef as ReactComponent };